<template>
  <div class="downloadWrapper">
    <download-icon class="downloadIcon" />
    <a :href="config.url" download target="_blank">{{ translatedLabel }}</a>
  </div>
</template>

<script>
import DownloadIcon from '~/components/icons/DownloadIcon'

export default {
  name: 'DxDownloadAdapter',
  components: { DownloadIcon },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    translatedLabel() {
      return this.$t(`downloads.${this.config.label}`)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/colors';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/typo';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/functions/px-to-rem';

.downloadWrapper {
  display: flex;
}
.downloadIcon {
  margin-right: rem(16);
  color: $functional-clr-info;
}
</style>
